<template>
  <v-checkbox
    class="CheckBox"
    :color="color || '#3c5aaa'"
    :label="label"
    v-model="localValue"
    hide-details="auto"
    density="compact"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>
<script>
export default {
  name: "CheckBox",
  props: {
    modelValue: { default: null },
    label:      { type: String,  default: "" },
    color:      { type: String,  default: "#3c5aaa" },
  },
  emits: ["update:modelValue"],
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.$emit("update:modelValue", val); },
    },
  },
};
</script>
<style lang="scss">
.CheckBox {
  .v-selection-control .v-label {
    white-space: normal;
    word-break: break-word;
    height: 100%;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
  }
  .v-checkbox .v-selection-control { min-height: unset !important; }
}
</style>